"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DollarFormat = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var react_number_format_1 = (0, tslib_1.__importDefault)(require("react-number-format"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var abbreviate_number_1 = require("../../formatters/abbreviate-number");
function DollarFormat(props) {
    var value = props.value, _a = props.format, format = _a === void 0 ? 'long' : _a;
    var prefix = isAbsoluteNegative(value) ? '($' : '$';
    var suffix = isAbsoluteNegative(value) ? ')' : '';
    return (React.createElement(StyledDiv, null,
        format === 'long' && (React.createElement(react_number_format_1.default, { displayType: "text", decimalScale: 2, fixedDecimalScale: true, value: value, thousandSeparator: true, prefix: prefix, suffix: suffix })),
        format === 'short' && "$".concat((0, abbreviate_number_1.abbreviateCurrencyNumber)(value))));
}
exports.DollarFormat = DollarFormat;
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
function isAbsoluteNegative(value) {
    return typeof value === 'string' && value.startsWith('(') && value.endsWith(')');
}
var templateObject_1;
//# sourceMappingURL=index.js.map